// Mock data for Steve Sattler Films portfolio
// This file contains all content that will later be served from the backend

export const siteInfo = {
  name: "Steve Sattler Films",
  tagline: "Honesty. Atmosphere. Connection.",
  heroSubtitle: "Independent Film | Music | Storytelling",
  email: "steve@stevesattlerfilms.com",
  copyright: `© ${new Date().getFullYear()} Steve Sattler Films. All rights reserved.`,
};

export const bioData = {
  paragraphs: [
    "As the creative force behind Steve Sattler Films, Steve has developed a body of work that spans independent film, music-related projects, and personal storytelling ventures.",
    "His projects often explore themes of identity, place, and memory—inviting audiences to not just watch, but feel.",
    "A commitment to honesty, atmosphere, and connection defines every frame. In addition to his film work, Sattler continues to expand his creative reach through music and writing, including projects such as My Country (2025) and Listen to London, further showcasing his multidisciplinary approach to storytelling.",
  ],
  images: {
    caricature: "/images/steve-music.png",
    london1980s: "/images/london1980s.jpg",
    caricatureCamera: "/images/caricature.png",
  },
};

export const featuredProjects = [
  {
    id: "listen-to-london",
    title: "Listen to London",
    year: "1980s",
    description: "An Emmy award-winning project filmed on the streets of London, capturing the pulse and spirit of the city through an authentic lens.",
    image: "/images/london1980s.jpg",
    type: "Featured Project",
  },
  {
    id: "my-country",
    title: "My Country",
    year: "2025",
    description: "A deeply personal exploration of place, belonging, and the landscapes that shape who we are.",
    image: null,
    type: "Upcoming Project",
  },
];

export const videoCategories = [
  {
    id: "music-videos",
    label: "Music Videos",
    videos: [
      {
        id: "Q2eAlmPWBTo",
        title: "Don't Cut Me Loose",
        thumbnail: "https://img.youtube.com/vi/Q2eAlmPWBTo/hqdefault.jpg",
        url: "https://youtu.be/Q2eAlmPWBTo",
      },
      {
        id: "yso5AXpCSCU",
        title: "Hindi Whispers — Director's Cut",
        thumbnail: "https://img.youtube.com/vi/yso5AXpCSCU/hqdefault.jpg",
        url: "https://youtu.be/yso5AXpCSCU",
      },
      {
        id: "nFCNtztpZGk",
        title: "Good Silence",
        thumbnail: "https://img.youtube.com/vi/nFCNtztpZGk/hqdefault.jpg",
        url: "https://youtu.be/nFCNtztpZGk",
      },
      {
        id: "gw6Ee8J9AJA",
        title: "Gonna' Make My Bed",
        thumbnail: "https://img.youtube.com/vi/gw6Ee8J9AJA/hqdefault.jpg",
        url: "https://youtu.be/gw6Ee8J9AJA",
      },
      {
        id: "wBMgokBKOgA",
        title: "You Shake Me Up",
        thumbnail: "https://img.youtube.com/vi/wBMgokBKOgA/hqdefault.jpg",
        url: "https://youtu.be/wBMgokBKOgA",
      },
      {
        id: "_mbWjsRFSGY",
        title: "Brave Little Tree",
        thumbnail: "https://img.youtube.com/vi/_mbWjsRFSGY/hqdefault.jpg",
        url: "https://youtu.be/_mbWjsRFSGY",
      },
    ],
  },
  {
    id: "corporate",
    label: "Corporate",
    videos: [
      {
        id: "cb3KqETkSK0",
        title: "CT Food Bank",
        thumbnail: "https://img.youtube.com/vi/cb3KqETkSK0/hqdefault.jpg",
        url: "https://youtu.be/cb3KqETkSK0",
      },
      {
        id: "QQ9gSHr8iGY",
        title: "Yale",
        thumbnail: "https://img.youtube.com/vi/QQ9gSHr8iGY/hqdefault.jpg",
        url: "https://youtu.be/QQ9gSHr8iGY",
      },
      {
        id: "sRLZGzJxZcE",
        title: "Caribbean in HD",
        thumbnail: "https://img.youtube.com/vi/sRLZGzJxZcE/hqdefault.jpg",
        url: "https://youtu.be/sRLZGzJxZcE",
      },
      {
        id: "pLQDbesya-I",
        title: "Off Soundings",
        thumbnail: "https://img.youtube.com/vi/pLQDbesya-I/hqdefault.jpg",
        url: "https://youtu.be/pLQDbesya-I",
      },
      {
        id: "QYBvJHO3iWI",
        title: "Fewer Sorties",
        thumbnail: "https://img.youtube.com/vi/QYBvJHO3iWI/hqdefault.jpg",
        url: "https://youtu.be/QYBvJHO3iWI",
      },
      {
        id: "-BC0bSgiLnk",
        title: "Visionary Marketing Demo",
        thumbnail: "https://img.youtube.com/vi/-BC0bSgiLnk/hqdefault.jpg",
        url: "https://youtu.be/-BC0bSgiLnk",
      },
    ],
  },
  {
    id: "tv-commercials",
    label: "TV Commercials",
    videos: [
      {
        id: "PplKNh0igXU",
        title: "TV Commercial I",
        thumbnail: "https://img.youtube.com/vi/PplKNh0igXU/hqdefault.jpg",
        url: "https://youtu.be/PplKNh0igXU",
      },
      {
        id: "NexftLKJeE8",
        title: "TV Commercial II",
        thumbnail: "https://img.youtube.com/vi/NexftLKJeE8/hqdefault.jpg",
        url: "https://youtu.be/NexftLKJeE8",
      },
      {
        id: "ay5W0a-Bfls",
        title: "TV Commercial III",
        thumbnail: "https://img.youtube.com/vi/ay5W0a-Bfls/hqdefault.jpg",
        url: "https://youtu.be/ay5W0a-Bfls",
      },
      {
        id: "Yd7qmjuA9VM",
        title: "TV Commercial IV",
        thumbnail: "https://img.youtube.com/vi/Yd7qmjuA9VM/hqdefault.jpg",
        url: "https://youtube.com/shorts/Yd7qmjuA9VM",
      },
    ],
  },
  {
    id: "photography",
    label: "Photography",
    videos: [
      {
        id: "w5hTNb6zd5w",
        title: "Photo Works 2023",
        thumbnail: "https://img.youtube.com/vi/w5hTNb6zd5w/hqdefault.jpg",
        url: "https://youtu.be/w5hTNb6zd5w",
      },
      {
        id: "v7GG5_6AjTQ",
        title: "2022 Art Book",
        thumbnail: "https://img.youtube.com/vi/v7GG5_6AjTQ/hqdefault.jpg",
        url: "https://youtu.be/v7GG5_6AjTQ",
      },
    ],
  },
  {
    id: "directors-commentary",
    label: "Director's Commentary",
    videos: [
      {
        id: "dzANJRMfhTU",
        title: "Listen to London — Director's Commentary",
        thumbnail: "https://img.youtube.com/vi/dzANJRMfhTU/hqdefault.jpg",
        url: "https://youtu.be/dzANJRMfhTU",
      },
      {
        id: "SlWIfrnAwfc",
        title: "Listen to London — Making of Book",
        thumbnail: "https://img.youtube.com/vi/SlWIfrnAwfc/hqdefault.jpg",
        url: "https://youtu.be/SlWIfrnAwfc",
      },
      {
        id: "orMCxAH303k",
        title: "WVIT Listen to London 1982",
        thumbnail: "https://img.youtube.com/vi/orMCxAH303k/hqdefault.jpg",
        url: "https://youtu.be/orMCxAH303k",
      },
      {
        id: "ZSvbbMfav8c",
        title: "Steve Sattler Films — TV Demo",
        thumbnail: "https://img.youtube.com/vi/ZSvbbMfav8c/hqdefault.jpg",
        url: "https://youtu.be/ZSvbbMfav8c",
      },
    ],
  },
  {
    id: "misc",
    label: "Misc",
    videos: [
      {
        id: "GbqqtVlJB40",
        title: "Out of Feelings",
        thumbnail: "https://img.youtube.com/vi/GbqqtVlJB40/hqdefault.jpg",
        url: "https://youtu.be/GbqqtVlJB40",
      },
      {
        id: "mrF0RK_mpLI",
        title: "Pigs in the Barn",
        thumbnail: "https://img.youtube.com/vi/mrF0RK_mpLI/hqdefault.jpg",
        url: "https://youtu.be/mrF0RK_mpLI",
      },
      {
        id: "Wy9Mpu0P9A8",
        title: "Glenda",
        thumbnail: "https://img.youtube.com/vi/Wy9Mpu0P9A8/hqdefault.jpg",
        url: "https://youtu.be/Wy9Mpu0P9A8",
      },
      {
        id: "AHrHLx-RqZE",
        title: "I Can Hear My Music",
        thumbnail: "https://img.youtube.com/vi/AHrHLx-RqZE/hqdefault.jpg",
        url: "https://youtu.be/AHrHLx-RqZE",
      },
      {
        id: "GFDdjfn4mIQ",
        title: "Touch My Music",
        thumbnail: "https://img.youtube.com/vi/GFDdjfn4mIQ/hqdefault.jpg",
        url: "https://youtu.be/GFDdjfn4mIQ",
      },
      {
        id: "x6GBrt-Uo54",
        title: "Got to Be True",
        thumbnail: "https://img.youtube.com/vi/x6GBrt-Uo54/hqdefault.jpg",
        url: "https://youtu.be/x6GBrt-Uo54",
      },
      {
        id: "R-FXkm--dng",
        title: "Not What Nature Planned",
        thumbnail: "https://img.youtube.com/vi/R-FXkm--dng/hqdefault.jpg",
        url: "https://youtu.be/R-FXkm--dng",
      },
      {
        id: "RdmfPz632lM",
        title: "Roses in the Cemetery",
        thumbnail: "https://img.youtube.com/vi/RdmfPz632lM/hqdefault.jpg",
        url: "https://youtu.be/RdmfPz632lM",
      },
      {
        id: "IYhg-fOxKBk",
        title: "Mary Had a Little Lamb",
        thumbnail: "https://img.youtube.com/vi/IYhg-fOxKBk/hqdefault.jpg",
        url: "https://youtu.be/IYhg-fOxKBk",
      },
      {
        id: "zIiALXSxmMs",
        title: "Listen to Your Brothers",
        thumbnail: "https://img.youtube.com/vi/zIiALXSxmMs/hqdefault.jpg",
        url: "https://youtu.be/zIiALXSxmMs",
      },
      {
        id: "wqQYDCKUrug",
        title: "She's Beautiful",
        thumbnail: "https://img.youtube.com/vi/wqQYDCKUrug/hqdefault.jpg",
        url: "https://youtu.be/wqQYDCKUrug",
      },
      {
        id: "RE3YmO7kVMk",
        title: "If You're Good, I'm Good",
        thumbnail: "https://img.youtube.com/vi/RE3YmO7kVMk/hqdefault.jpg",
        url: "https://youtu.be/RE3YmO7kVMk",
      },
      {
        id: "c3WTPKHTr6M",
        title: "Not Just a Little Bit",
        thumbnail: "https://img.youtube.com/vi/c3WTPKHTr6M/hqdefault.jpg",
        url: "https://youtu.be/c3WTPKHTr6M",
      },
      {
        id: "Jg-7A5q7RYg",
        title: "She's Got That Special Thingy",
        thumbnail: "https://img.youtube.com/vi/Jg-7A5q7RYg/hqdefault.jpg",
        url: "https://youtu.be/Jg-7A5q7RYg",
      },
      {
        id: "eHYQlBWtsGQ",
        title: "7 Wrong Notes",
        thumbnail: "https://img.youtube.com/vi/eHYQlBWtsGQ/hqdefault.jpg",
        url: "https://youtu.be/eHYQlBWtsGQ",
      },
      {
        id: "-XSbByu64tI",
        title: "Listen to Me",
        thumbnail: "https://img.youtube.com/vi/-XSbByu64tI/hqdefault.jpg",
        url: "https://youtu.be/-XSbByu64tI",
      },
      {
        id: "pKvbPDC6j9A",
        title: "The Littlest George",
        thumbnail: "https://img.youtube.com/vi/pKvbPDC6j9A/hqdefault.jpg",
        url: "https://youtu.be/pKvbPDC6j9A",
      },
      {
        id: "m0llbF5xvms",
        title: "Littlest George 03",
        thumbnail: "https://img.youtube.com/vi/m0llbF5xvms/hqdefault.jpg",
        url: "https://youtu.be/m0llbF5xvms",
      },
      {
        id: "336-YRht-vE",
        title: "Twinkle, Twinkle Little Star",
        thumbnail: "https://img.youtube.com/vi/336-YRht-vE/hqdefault.jpg",
        url: "https://youtu.be/336-YRht-vE",
      },
    ],
  },
];

export const navLinks = [
  { label: "Films", href: "#work" },
  { label: "About", href: "#about" },
  { label: "Projects", href: "#projects" },
  { label: "Contact", href: "#contact" },
];
